import(/* webpackMode: "eager" */ "/opt/build/repo/components/Residents/page.tsx")